<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商品分组
      <small>/&nbsp;分组列表</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">分组列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">分组查询</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="分组编号/分组名称"
                          v-model="fuzzy"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">企业名称</label>
                      <div class="col-md-2">
                        <el-select
                          v-model="companyId"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in companyList "
                            :key="item.id "
                            :label="item.commerceName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-1">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                          style="float:right;"
                        >查询</a>
                      </div>
                      <div class="col-md-8"></div>
                      <div class="col-md-11"></div>
                      <div class="col-md-1">
                        <a
                          class="btn btn-primary ButtonColor"
                          @click="AddClick()"
                          style="float:right;"
                        >新增</a>
                      </div>

                    </div>
                    <div class="form-group row m-b-15"></div>
                  </fieldset>
                </form>

                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column prop="groupCode" label="分组编号" align="center"></el-table-column>
                  <el-table-column prop="groupName" label="分组名称" align="center"></el-table-column>
                  <el-table-column prop="noted" label="分组描述" align="center"></el-table-column>
                  <el-table-column prop="companyName" label="企业名称" align="center"></el-table-column>
                  <el-table-column label="分组报价" align="center" width="100">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="PriceClick(scope.row,scope.index)"
                      >分组报价
                      </button>

                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="140" align="center">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="EditClick(scope.row)"
                      >编辑
                      </button>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"

                        @click="DeleteClick(scope.row)"
                      >删除
                      </button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px" :before-close="handleClose">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <div class="swal-button-container">
              <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled="disabled">
                确定
              </button>
            </div>
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消
            </div>
          </div>

        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="分组编号:" prop="groupCode">
            <el-input v-model="ruleForm.groupCode" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="分组名称:" prop="groupName">
            <el-input v-model="ruleForm.groupName" class="DistributorMargin"></el-input>
          </el-form-item>

        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              :disabled="disabled"
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
            >确定
            </button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消
            </div>
          </div>

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from 'qs'
import axios from 'axios'
import http from '../../common/http'
import MethodsBus from '../../common/methodBus'

export default {
  name: 'GroupOrderList',
  data () {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      status: '1',
      outerVisible: false,
      disabled: false,
      DialogTitle: '编辑',
      CloseShow: false,
      EditDialog: 1,
      CurrentSelection: [],
      fuzzy: '',
      companyId: '',
      StateOptions: [
        {
          label: '删除',
          value: 0
        },
        {
          label: '正常',
          value: 1
        }
      ],
      ruleForm: {
        groupCode: '',
        groupName: '',
      },
      rules: {
        groupName: [
          {required: true, message: '请输入分组名称', trigger: 'blur'}
        ],
        groupCode: [
          {required: true, message: '请输入分组编号', trigger: 'blur'}
        ]
      },
      UserManagementEdit: '',
      TimeValue: '',
      UserManagementList: [],
      currentPage: 1,
      companyList: []
    }
  },
  watch: {
    pageNo: {
      handler (newName, oldName) {
        if (this.$route.params) {
          this.pageNo = this.$route.params.pageNo
        }

      },
      immediate: true
    },
    pagesize: {
      handler (newName, oldName) {

        if (JSON.stringify(this.$route.params) !== '{}') {
          this.pageSize = this.$route.params.pagesize

        }

      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set (val) {
        if (val) {

          this.pageindex = val
        }

      },
      get () {
        //   console.log('我被调用了') //msg1获取值时触发

      }
    },
    pagesize: {
      set (val) {
        if (val) {
          this.pageSize = val
        }

      },
      get () {
        //console.log('我被调用了') //msg1获取值时触发

      }
    }
  },
  mounted: function () {
    if (JSON.stringify(this.$route.params) !== '{}') {
      this.fuzzy = JSON.parse(this.$route.params.firstSearchContent).fuzzy
    }
    this.initdata()
    this.getCompanyList()
  },
  methods: {
    getCompanyList () {
      let that = this
      const options = {
        url: 'distribution/B2cOrderInfoController/parsingUser',
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: Qs.stringify({})
      }
      axios(options)
        .then(response => {
          if (response.data.code === 200) {
            that.companyList = response.data.data.result
          } else {
            http.handleEorrorCode(response, this)
          }
        })
        .catch(error => {
          http.handleEorrorCode(response, this)
        })
    },
    EnterSelect () {
      if (this.status !== '请选择') {
        this.CloseShow = true
      }
    },
    LeaveSelect () {
      this.CloseShow = false
    },
    ClearSelect () {
      this.status = '请选择'
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.pageindex = 1
      this.initdata()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.initdata()
    },
    PriceClick (row, index) {
      let firstSearchContent = {}
      firstSearchContent.fuzzy = this.fuzzy
      this.$router.push({
        name: 'PackManagement',
        query: {
          groupId: row.groupId,
          firstpageSize: this.pageSize,
          firstpageIndex: this.pageindex,
          firstSearchContent: JSON.stringify(firstSearchContent)
        }
      })

    },
    EditClick (row) {
      this.outerVisible = true
      this.DialogTitle = '编辑'
      this.EditDialog = 1
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.ruleForm = MethodsBus.cloneRow(row)
    },
    DeleteClick (item) {
      this.outerVisible = true
      this.EditDialog = 2
      this.CurrentSelection = item
    },
    // 新增
    AddClick () {
      this.ruleForm = {}
      this.outerVisible = true
      this.DialogTitle = '新增'
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.EditDialog = 1
    },
    SearchClick () {
      this.pageindex = 1
      this.initdata()
    },

    MakeSureEdit (formName) {
      let that = this
      if (this.DialogTitle === '编辑') {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true
            const options = {
              url: 'distribution/B2cGroupInfoController/updateGroup',
              method: 'post',
              headers: {'Content-Type': 'application/x-www-form-urlencoded'},
              data: Qs.stringify({
                groupId: that.ruleForm.groupId,
                groupCode: that.ruleForm.groupCode,
                groupName: that.ruleForm.groupName.replace(/\s+/g, '')
              })
            }
            axios(options)
              .then(function (response) {
                that.outerVisible = false
                that.disabled = false
                if (response.data.code == 200) {
                  that.initdata()
                  that.$notify({
                    title: '成功',
                    message: '修改成功',
                    type: 'success'
                  })
                } else {
                  http.handleEorrorCode(response, that)
                }
              })
              .catch(function (error) {
                that.outerVisible = false
                that.disabled = false
                http.handleHttpError(error, that)
              })
          } else {
            this.outerVisible = true
          }
        })
      } else if (this.DialogTitle === '新增') {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true
            const options = {
              url: 'distribution/B2cGroupInfoController/addGroup',
              method: 'post',
              headers: {'Content-Type': 'application/x-www-form-urlencoded'},
              data: Qs.stringify({
                groupId: that.ruleForm.groupId,
                groupCode: that.ruleForm.groupCode,
                groupName: that.ruleForm.groupName.replace(/\s+/g, '')
              })
            }
            axios(options)
              .then(function (response) {
                that.outerVisible = false
                that.disabled = false
                if (response.data.code == 200) {
                  that.initdata()
                  that.$notify({
                    title: '成功',
                    message: '新增成功',
                    type: 'success'
                  })
                } else {
                  http.handleEorrorCode(response, that)
                }
              })
              .catch(function (error) {
                that.outerVisible = false
                that.disabled = false
                http.handleHttpError(error, that)
              })
          } else {
            this.outerVisible = true
          }
        })
      }
    },
    MakeSure () {
      let that = this
      that.disabled = true
      axios
        .post(
          'distribution/B2cGroupInfoController/deleteGroup?groupId=' +
          this.CurrentSelection.groupId
        )
        .then(function (response) {
          that.outerVisible = false
          that.disabled = false
          if (response.data.code == 200) {
            that.initdata()
            that.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(function (error) {

          that.disabled = false
          http.handleHttpError(error, that)
        })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    initdata () {
      let that = this
      // let status =''
      // if(that.status !== '请选择'){
      //   status =  that.status;
      // }else{
      //   status = ''
      // }
      const options = {
        url: 'distribution/B2cGroupInfoController/queryGroups',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          fuzzy: that.fuzzy,
          companyId: that.companyId,
          status: that.status,
          size: that.pageSize,
          current: that.pageindex
        })
      }
      axios(options).then(function (response) {
        if (response.data.code == 200) {
          that.totalCount = response.data.data.total
          for (var i in response.data.data.records) {
            response.data.data.records[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1
            // if (response.data.data.records[i].status === 0) {
            //   response.data.data.records[i].disabled = true;
            //   response.data.data.records[i].currentstatus = "删除";
            // } else if (response.data.data.records[i].status === 1) {
            //   response.data.data.records[i].disabled = false;
            //   response.data.data.records[i].currentstatus = "正常";
            // }else if(response.data.data.records[i].status === -1){
            //     response.data.data.records[i].currentstatus = "全部";
            // }
          }

          that.UserManagementList = response.data.data.records
        } else {
          http.handleEorrorCode(response, that)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .clear {
    clear: both;
  }

  .PaginationStyle {
    float: right;
    margin-top: 8px;
  }

  .panelTitle {
    padding-left: 15px;
    text-align: left;
  }

  .ButtonColor {
    color: #fff !important;
  }

  .ModelPadding {
    margin-top: -20px;
  }

  .LineSpacing {
    margin-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/GroupManage/GroupOrderList.vue